var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
import { insertAfter } from '../helpers/elements';
var MultiInputEditable = /** @class */ (function (_super) {
    __extends(MultiInputEditable, _super);
    function MultiInputEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiInputEditable.prototype.render = function () {
    };
    MultiInputEditable.prototype.valueToInput = function (values) {
        var _this = this;
        if (!values || (Array.isArray(values) && values.length === 0)) {
            values = [''];
        }
        values.forEach(function (value) {
            var input = _this.createSingleInput(value);
            _this.getElement().querySelector('.acp-ie-multi-container').append(input);
        });
    };
    MultiInputEditable.prototype.createSingleInput = function (value) {
        var subtype = this._args.subtype;
        var container = document.createElement('div');
        var input = null;
        container.classList.add('single-input');
        switch (subtype) {
            case 'textarea':
                input = this._template.form.textarea('input', value);
                break;
            default:
                input = this._template.form.input('input', value, { type: this._args.subtype });
        }
        input.value = value;
        if (!input) {
            return;
        }
        container.append(input);
        container.append(this.createControls());
        return container;
    };
    MultiInputEditable.prototype.deterimineControls = function () {
        var lines = this.getElement().querySelectorAll('.single-input').length;
        if (lines > 1) {
            this.getElement().querySelectorAll('.single-input__control.-remove').forEach(function (e) { return e.style.display = 'inline-block'; });
        }
        else {
            this.getElement().querySelectorAll('.single-input__control.-remove').forEach(function (e) { return e.style.display = 'none'; });
        }
    };
    MultiInputEditable.prototype.createControls = function () {
        var _this = this;
        var controls = document.createElement('div');
        controls.classList.add('single-input__controls');
        controls.innerHTML = "\n\t\t\t<span class=\"single-input__control -add\">\n\t\t\t\t<span class=\"dashicons dashicons-plus\"></span>\n\t\t\t</span>\n\t\t\t<span class=\"single-input__control -remove\">\n\t\t\t\t<span class=\"dashicons dashicons-minus\"></span>\n\t\t\t</span>\n\t\t";
        controls.querySelector('.-add').addEventListener('click', function (e) {
            _this.eventNewRow(e);
        });
        controls.querySelector('.-remove').addEventListener('click', function (e) {
            e.target.closest('.single-input').remove();
            _this.deterimineControls();
        });
        setTimeout(function () {
            _this.deterimineControls();
        }, 0);
        return controls;
    };
    MultiInputEditable.prototype.eventNewRow = function (e) {
        var input = e.target.closest('.single-input');
        if (input) {
            insertAfter(this.createSingleInput(''), input);
        }
    };
    MultiInputEditable.prototype.getValue = function () {
        var value = [];
        this.getElement().querySelectorAll('.single-input input, .single-input textarea').forEach(function (input) {
            value.push(input.value);
        });
        return value;
    };
    MultiInputEditable.prototype.getTemplate = function () {
        return "<div class=\"acp-ie-multi-container\"></div>";
    };
    MultiInputEditable.prototype._setDefaults = function () {
        this._defaults.type = 'multi_input';
        this._defaults.subtype = 'text';
    };
    return MultiInputEditable;
}(AbstractEditable));
export default MultiInputEditable;
